import { RequestInstance } from "../../utils/request";

export const login = new RequestInstance({
  method: "post",
  url: "/service-energy/v1/member/login",
});

export const memberAuthModuleList = new RequestInstance({
  method: "get",
  url: "/v2/member/auth/module/list",
});

export const memberSystemList = new RequestInstance({
  method: "get",
  url: "/v2/member/system/list",
});

export const userInfo = new RequestInstance({
  method: "get",
  url: "/v2/user/info",
});
